import { useState } from "react";

export const useRetailerSearch = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  return {
    searchQuery,
    setSearchQuery,
    open,
    setOpen,
  };
};
